<div class="container-fluid hero-container">
  <div class="img-container">
  </div>
  <div class="hero-callout">
    <div class="row">
      <div class="col-12 text-center">
        <h1>
          High Quality, Low Cost
          <br class="d-none d-md-block">
          Heavy Equipment Parts
        </h1>
      </div>
      <div class="col-12 col-md-6 mt-4 d-grid">
        <a [routerLink]="['/quote']" class="btn btn-outline-primary quote-btn">
          Get A Quote
        </a>
      </div>
      <div class="col-12 col-md-6 mt-4 d-grid">
        <a [routerLink]="['/shop']" class="btn btn-outline-primary btn-block parts-btn">
          Search Parts
        </a>
      </div>
    </div>
  </div>
</div>
<div class="container second-container">
  <div class="row">
    <div class="col-12 mt-5 text-center">
      <h2>IHM Used Parts</h2>
      <p class="follow-text">
        Quality Used Parts... Guaranteed!
      </p>
    </div>
    <div class="col-12 mt-4 youtube-col">
      <div class="row">
        <div class="col-12 col-md-6" #youTubeCol>
          <youtube-player #youTubePlayerEl (ready)="onPlayerReady($event)" videoId="NVwyxJ33p8I"
            suggestedQuality="highres" [height]="youtubeHeight" [width]="youtubeWidth">
          </youtube-player>
        </div>
        <div class="col-12 col-md-6 mt-5 mt-lg-0">
          <div class="row">
            <div class="col-12 ps-md-5">
              <p>IHM Used Parts is a family owned business specializing in Caterpillar parts among others
                including Bobcat,
                Case and John Deere. Equipped with southern hospitality, a streamlined business process, and exceptional
                customer service, IHM Used Parts has grown tremendously over the years and continues to improve and expand.
                Whether in the region or across the ocean, IHM Used Parts will deliver used parts to you.
              </p>
              <div class="row">
                <div class="mt-4 mt-lg-5 col-12 col-lg-6 d-grid">
                  <a [routerLink]="['/about']" class="btn btn-outline-primary learn-btn">
                    Learn More
                  </a>
                </div>
                <div class="mt-4 mt-lg-5 col-12 col-lg-6 d-grid">
                  <a [routerLink]="['/blog']" class="btn btn-outline-primary blog-btn">
                    Check Out Our Blog
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cat-spacer col-12 mt-5">
      <hr class="d-none d-md-flex">
    </div>
    <div class="col-12 cat-parts-col mb-5">
      <div class="row">
        <div class="d-none d-md-block col-6">
          <h3>Save 30-70% OFF Used<br class="d-none d-md-block"> Caterpillar Parts</h3>
          <p class="follow-text">
            for Cat Dozers, excavators, graders, backhoes, and other Cat construction<br class="d-none d-md-block"> equipment.
          </p>
          <p>
            IHM Used Parts is a reliable and experienced dealer in used<br class="d-none d-md-block"> Caterpillar and other heavy equipment
            manufacturer parts. We<br class="d-none d-md-block"> keep a large selection of dozer parts and even most final drives<br class="d-none d-md-block"> in stock.
          </p>
          <a [routerLink]="['/shop/caterpillar/parts']" class="btn btn-outline-primary learn-btn cat-btn mt-md-4">
            Shop Caterpillar Used Parts
          </a>
        </div>
        <div class="col-12 col-md-6 d-inline-flex">
          <img class="img img-responsive cat-img flex ms-md-auto" loading="lazy"
            src="assets/images/photo-caterpillar-excavator-claw@2xOptimized.webp" alt="Caterpillar Used Parts" />
        </div>
        <div class="col-12 d-block d-md-none mt-4">
          <h3>Save 30-70% OFF Used Caterpillar Parts</h3>
          <p class="follow-text">
            for Cat Dozers, excavators, graders, backhoes, and other Cat construction equipment.
          </p>
          <p class="follow-text-small">
            IHM Used Parts is a reliable and experienced dealer in used Caterpillar and other heavy equipment
            manufacturer parts. We keep a large selection of dozer parts and even most final drive in stock.
          </p>
          <a [routerLink]="['/shop/caterpillar/parts']" class="btn btn-outline-primary learn-btn cat-btn d-block">
            Shop Caterpillar Used Parts
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid bottom-container">
  <div class="container">
    <div class="row">
      <app-mailing-list></app-mailing-list>
    </div>
  </div>
</div>
